import { useMemo } from 'react'
import { useCurrentUser } from '@cma/app'
import { CmaPermissionIdEnum } from '@cma/generated/graphql'

type UseRosterPermissionsReturn = {
  hasRosterPermissions: boolean
}

export function useRosterPermissions(): UseRosterPermissionsReturn {
  const { data: { currentUser } = {} } = useCurrentUser()

  return useMemo(() => {
    const userPermissions = currentUser?.permissions ?? []

    const permissionSet = new Set(
      userPermissions.map((permission) => permission.permissionId)
    )

    const hasRosterPermissions = permissionSet.has(
      CmaPermissionIdEnum.CmaAdminImpersonate
    )

    return {
      hasRosterPermissions
    }
  }, [currentUser?.permissions])
}
